import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  query get_organization_worker_list_(
    $filter: organizationFilterInput
    $pagination: paginationInput
    $sort: [sortInput]
  ) {
    getOrganizationList(
      filter: $filter
      pagination: $pagination
      sort: $sort
    ) {
      items {
        parentOrganization
        updateReferenceId
        thirdPopulation
        femalePopulation
        malePopulation
        logoUrl
        mobile
        email
        levelId
        groupId
        type
        usernamePrefix
        shortName
        name
        id
      }
      pagination {
        totalCount
        pageLimit
        pageNumber
      }
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.OrganizationListState = {
  result: null,
  error: null,
  loading: false
};

export const get_organization_worker_list__request = createAsyncThunk<
  TYPES.OrganizationList,
  {
    filter?: TYPES.OrganizationFilterInput;
    pagination?: TYPES.PaginationInput;
    sort?: TYPES.SortInput[];
  },
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/get_organization_worker_list_',
  async (
  params: {
    filter?: TYPES.OrganizationFilterInput;
    pagination?: TYPES.PaginationInput;
    sort?: TYPES.SortInput[];
  },
  { extra: client }) =>
  {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getOrganizationList;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const get_organization_worker_list__slice = createSlice({
  name: 'get_organization_worker_list_',
  initialState: initialState,
  reducers: {
    get_organization_worker_list__clear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(get_organization_worker_list__request.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      get_organization_worker_list__request.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      get_organization_worker_list__request.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { get_organization_worker_list__clear } =
get_organization_worker_list__slice.actions;

export const get_organization_worker_list_ = createSelector(
  (state: RootState) => state.organization.get_organization_worker_list_.result,
  (state: RootState) => state.organization.get_organization_worker_list_.error,
  (state: RootState) =>
  state.organization.get_organization_worker_list_.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default get_organization_worker_list__slice.reducer;